import { forwardRef } from "react"
import { Input as SingleInput } from "../Input"

export type InputProps = Omit<React.ComponentPropsWithRef<typeof SingleInput>, `variant`>

const Input: React.FC<InputProps> = forwardRef(({ ...inputProps }, forwardedRef) => (
  <SingleInput ref={forwardedRef} variant="form" {...inputProps} />
))

Input.displayName = `InputGroup.Input`

export { Input }
